export default "__VITE_ASSET__BItBcyKa__"